import classNames from "classnames/bind";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import type { MembershipAdvantage } from "../types";
import styles from "./MembershipBlock.module.scss";

const cx = classNames.bind(styles);

type MembershipAdvantagesProps = {
	advantages: MembershipAdvantage[];
};

/** Benefits of signing up. Each picto only illustrates the text next to it, so it is hidden from assistive technologies. */
export const MembershipAdvantages = ({ advantages }: MembershipAdvantagesProps) => (
	<ul className={cx("membership-block__advantages")}>
		{advantages.map(({ _key, picto, advantageText }) => (
			<li key={_key ?? advantageText} className={cx("membership-block__advantage")}>
				<img
					className={cx("membership-block__advantage-picto")}
					src={picto}
					alt=""
					width={20}
					height={20}
					loading="lazy"
				/>

				<Typography component="span" variant={TYPOGRAPHY_VARIANTS.REGULAR} isBold>
					{advantageText}
				</Typography>
			</li>
		))}
	</ul>
);
